module.exports = __webpack_public_path__ + "static/img/img1.c54a09e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic/img1.png
// module id = xRCJ
// module chunks = 0